module.exports = __webpack_public_path__ + "static/media/DSC_0354.163989b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0354.jpg
// module id = 597
// module chunks = 0